import { EntitlementStatementSimple } from '@dreryk/egabinet-patient-frontend-api';

import { AddCircleIcon, EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../translations';
import { EntitlementStatementCreateLink } from '../create/EntitlementStatementCreateLink';

import {
   useEntitlementStatementsDataConfiguration,
   useEntitlementStatementsTableColumns,
} from './EntitlementStatementsTable.hooks';

type EntitlementStatementsTableProps = {
   readonly patientId: number;
};

export const EntitlementStatementsTable = (props: EntitlementStatementsTableProps): JSX.Element => {
   const dataConfiguration = useEntitlementStatementsDataConfiguration({
      patientId: props.patientId,
   });
   const columns = useEntitlementStatementsTableColumns(dataConfiguration.refetch);

   return (
      <Table<EntitlementStatementSimple>
         testId={'entitlementStatements'}
         keyExtractor={'id'}
         columns={columns}
         dataConfiguration={dataConfiguration}
         pageSize={5}
         placeholder={
            <EmptyStatePlaceholder
               heading={entitlementStatementsTranslationKeys.noAdditionalEntitlements}
               subheading={entitlementStatementsTranslationKeys.noAdditionalEntitlementsAssignedToPatient}
               testId={'noEntitlementStatements'}
            >
               <EntitlementStatementCreateLink
                  patientId={props.patientId}
                  label={entitlementStatementsTranslationKeys.addEntitlementStatement}
                  onPatientEntitlementsDocumentCreated={dataConfiguration.refetch}
               />
            </EmptyStatePlaceholder>
         }
         bottomElement={
            <EntitlementStatementCreateLink
               patientId={props.patientId}
               label={entitlementStatementsTranslationKeys.addEntitlementStatement}
               icon={<AddCircleIcon />}
               onPatientEntitlementsDocumentCreated={dataConfiguration.refetch}
            />
         }
      />
   );
};
